import { render, staticRenderFns } from "./GlobalLoginModal - 副本.vue?vue&type=template&id=3993737d&scoped=true"
import script from "./GlobalLoginModal - 副本.vue?vue&type=script&lang=js"
export * from "./GlobalLoginModal - 副本.vue?vue&type=script&lang=js"
import style0 from "./GlobalLoginModal - 副本.vue?vue&type=style&index=0&id=3993737d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3993737d",
  null
  
)

export default component.exports